import { render, staticRenderFns } from "./Actas.vue?vue&type=template&id=3e5c6775"
import script from "./Actas.vue?vue&type=script&lang=js"
export * from "./Actas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e5c6775')) {
      api.createRecord('3e5c6775', component.options)
    } else {
      api.reload('3e5c6775', component.options)
    }
    module.hot.accept("./Actas.vue?vue&type=template&id=3e5c6775", function () {
      api.rerender('3e5c6775', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/Actas.vue"
export default component.exports